module.exports = __webpack_public_path__ + "img/radio_checked.55292a60.webp";